import type { UseQueryOptions, UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';

import { apiClient } from 'api/apiClient';
import type { TExpectedDecisionMaker } from 'api/types/edm';
import type { IRequestException } from 'api/types/requestException';

interface ICreateEdmProps
    extends UseQueryOptions<TExpectedDecisionMaker, IRequestException> {
    data: Partial<TExpectedDecisionMaker>;
    leadId: number;
}

const createEdm = async ({ data, leadId }: ICreateEdmProps) => {
    const response = await apiClient.post(`property-leads/${leadId}/edms`, {
        json: {
            ...data,
        },
    });
    return (await response.json()) as TExpectedDecisionMaker;
};

export const useCreateEdmMutation = (
    options: UseMutationOptions<
        TExpectedDecisionMaker,
        IRequestException,
        ICreateEdmProps
    >
) => {
    return useMutation<
        TExpectedDecisionMaker,
        IRequestException,
        ICreateEdmProps
    >(async (data) => await createEdm(data), options);
};
